import autosize from "autosize";

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.js-autosize').forEach(function (element) {
        autosize(element);
    });
});
